module.exports = __webpack_public_path__ + "img/ico_atualizacao-cadastro.da971b7a.svg";